import { useQuery } from '@tanstack/react-query';

import { getJobTitles } from '../services/api/job-title';

export function useJobTitle() {
  return useQuery({
    queryKey: ['jobTitles'],
    queryFn: async () => {
      const data = await getJobTitles();
      return data;
    },
  });
}
